(function() {
  define('bazemont/booking/datepicker',['angular'], function() {
    'use strict';
    return angular.module('bazemontBookingDatepicker', []).component('bazemontBookingDatepicker', {
      template: '<div uib-datepicker ng-model-options="{timezone: \'utc\'}" class="nice-datepicker" ng-model="$ctrl.selectedDate" datepicker-options="$ctrl.datepickerOptions"></div>',
      bindings: {
        selectedDate: '=',
        selectableDates: '<'
      },
      controller: [
        '$http', function($http) {
          var getDayClass, vm;
          vm = this;
          getDayClass = function(data) {
            var className, currentDate, date, mode, selectableDate, today, _i, _len, _ref;
            className = null;
            mode = data.mode;
            if (mode === 'day') {
              currentDate = new Date(data.date).setHours(0, 0, 0, 0);
              today = new Date().setHours(0, 0, 0, 0);
              if (today === currentDate) {
                className = 'today';
              } else if (vm.selectableDates) {
                _ref = vm.selectableDates;
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                  selectableDate = _ref[_i];
                  date = new Date(selectableDate).setHours(0, 0, 0, 0);
                  if (currentDate === date) {
                    className = 'highlight selectable';
                    break;
                  }
                }
              }
            }
            return className;
          };
          vm.$onInit = function() {
            return vm.datepickerOptions = {
              showWeeks: false,
              startingDay: 1,
              customClass: getDayClass
            };
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=datepicker.js.map
;
